export class CheckAzureDiskEncryptionSetAccessResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "readable",
            "baseName": "readable",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "diskEncryptionSet",
            "baseName": "diskEncryptionSet",
            "type": "AzureDiskEncryptionSet",
            "format": ""
        },
        {
            "name": "problem",
            "baseName": "problem",
            "type": "AzureDiskEncryptionSetAccessProblem",
            "format": ""
        },
        {
            "name": "message",
            "baseName": "message",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CheckAzureDiskEncryptionSetAccessResponse.attributeTypeMap;
    }
    constructor() {
    }
}
